import { render, staticRenderFns } from "./FieldRadio.vue?vue&type=template&id=528c7215"
import script from "./FieldRadio.vue?vue&type=script&lang=js"
export * from "./FieldRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports